import CreatePronunciationAssessmentView from "@features/tools/view/pronunciation-assessment-view/create-pronunciation-assessment-view";

const CreatePronunciationAssessment = () => {
  return <CreatePronunciationAssessmentView />;
};

export default CreatePronunciationAssessment;
